<template>
  <div id="searchLocationContainer">
    <div class="row justify-content-between align-items-end">
      <div class="col">
        <TitleBreadcrumb :page="page" />
      </div>
      <div>
        <ActionButton
          i="fas fa-arrow-circle-left"
          variant="outline-success m-2"
        >
          Regresar
        </ActionButton>
        <ActionButton
          i="fas fa-file-plus"
          variant="success m-2"
          @click="showAddLocation = true"
        >
          Añadir
        </ActionButton>
      </div>
    </div>
    <div class="dropdown-divider w-100" />
    <SectionTitle content="Busqueda de Ubicaciones" />
    <div class="dropdown-divider w-100" />
    <div class="mx-1">
      <ValidationObserver ref="searchLocationObserver">
        <form ref="searchLocationForm" class="main-content mt-2" novalidate>
          <div class="row">
            <div class="col-3">
              <div class="form-group">
                <ValidationProvider
                  v-slot="{ errors, dirty }"
                  name="Pueblo"
                  rules="required"
                >
                  <CustomDropDown
                    id="cboPueblo"
                    label="Pueblo:"
                    fieldkey="id"
                    fieldname="name"
                    placeholder="Seleccionar Pueblo"
                  />
                </ValidationProvider>
              </div>
            </div>
            <div class="col-3">
              <div class="form-group">
                <ValidationProvider
                  v-slot="{ errors, dirty }"
                  name="Nombre"
                  rules="required"
                >
                  <CustomInput
                    id="txtNombre"
                    label="Nombre:"
                    placeholder="Escribir Nombre"
                  />
                </ValidationProvider>
              </div>
            </div>
            <div class="col-3">
              <div class="form-group">
                <ValidationProvider
                  v-slot="{ errors, dirty }"
                  name="Telefono"
                  rules="required"
                >
                  <CustomInput
                    id="txtTelefono"
                    label="Teléfono:"
                    placeholder="(787) ###-####"
                  />
                </ValidationProvider>
              </div>
            </div>
            <div class="col-3 text-end pt-5 pb-1">
              <ActionButton variant="success m-2" class="min-width">
                Buscar
              </ActionButton>
            </div>
          </div>
        </form>
      </ValidationObserver>

      <div class="row mt-2">
        <div class="col-12">
          <SectionTitle content="Resultado de Búsqueda" />
          <div class="dropdown-divider w-100" />
          <div class="row">
            <div class="col-12">
              <vue-good-table
                mode="remote"
                style-class="table vgt-searchLocation striped table-hover"
                :rows="tableConfig.rows"
                :columns="tableConfig.columns"
                :sort-options="{
                  enabled: false,
                }"
                :pagination-options="{
                  enabled: true,
                }"
              >
                <div slot="emptystate">
                  <div class="text-center text-gray">
                    Complete los campos de búsqueda de ubicaciones para
                    visualizar los datos.
                  </div>
                </div>
                <template slot="table-row" slot-scope="props">
                  <span v-if="props.column.label == 'Acciones'">
                    <DropDown
                      :items="[
                        {
                          Title: 'Seleccionar',
                          Icon: 'fa fa-check-square text-green',
                          Item: props.formattedRow, //Validar como obtener el objeto
                        },
                        {
                          Title: 'Eliminar',
                          Icon: 'fa fa-times-circle text-red',
                          Item: props.formattedRow, //Validar como obtener el objeto
                        },
                        {
                          Title: 'Editar',
                          Icon: 'fa fa-edit text-green',
                          Item: props.formattedRow, //Validar como obtener el objeto
                        },
                      ]"
                    />
                  </span>
                </template>
                <template slot="pagination-bottom" slot-scope="props">
                  <customPager
                    ref="historyPager"
                    :per-page="tableConfig.serverParams.perPage"
                    :total="props.total"
                    :page-changed="props.pageChanged"
                    :per-page-changed="props.perPageChanged"
                  />
                </template>
              </vue-good-table>
            </div>
          </div>
        </div>
      </div>
      <div class="dropdown-divider w-100" />
      <div v-if="showAddLocation" class="row mt-2 px-2">
        <div class="col-12">
          <CustomCollapse class="mt-2">
            <CustomCollapseItem
              title="Añadir Ubicación"
              :selected="true"
              expanded
            >
              <div class="row">
                <div class="col-12 px-4">
                  <ValidationObserver ref="addLocationObserver">
                    <form
                      ref="addLocationForm"
                      class="main-content mt-2"
                      novalidate
                    >
                      <div class="row">
                        <div class="col-4">
                          <div class="form-group">
                            <ValidationProvider
                              v-slot="{ errors, dirty }"
                              name="LocationName"
                              rules="required"
                            >
                              <CustomInput
                                id="txtLocationName"
                                label="Nombre de Ubicación:"
                                placeholder="Escribir Nombre"
                              />
                            </ValidationProvider>
                          </div>
                        </div>
                        <div class="col-4">
                          <div class="form-group">
                            <ValidationProvider
                              v-slot="{ errors, dirty }"
                              name="Line1"
                              rules="required"
                            >
                              <CustomInput
                                id="txtLine1"
                                label="Línea 1:"
                                placeholder="Escribir Línea 1 de dirección"
                              />
                            </ValidationProvider>
                          </div>
                        </div>
                        <div class="col-4">
                          <div class="form-group">
                            <ValidationProvider
                              v-slot="{ errors, dirty }"
                              name="Line2"
                              rules="required"
                            >
                              <CustomInput
                                id="txtLine2"
                                label="Línea 2:"
                                placeholder="Escribir Línea 2 de dirección"
                              />
                            </ValidationProvider>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-4">
                          <div class="form-group">
                            <ValidationProvider
                              v-slot="{ errors, dirty }"
                              name="LocationTelephone"
                              rules="required"
                            >
                              <CustomInput
                                id="txtLocationTelephone"
                                label="Teléfono de Ubicación:"
                                placeholder="(787) ###-####"
                              />
                            </ValidationProvider>
                          </div>
                        </div>
                        <div class="col-4">
                          <div class="form-group">
                            <ValidationProvider
                              v-slot="{ errors, dirty }"
                              name="LocationPueblo"
                              rules="required"
                            >
                              <CustomDropDown
                                id="cboLocationPueblo"
                                label="Pueblo:"
                                fieldkey="id"
                                fieldname="name"
                                placeholder="Seleccionar Pueblo"
                              />
                            </ValidationProvider>
                          </div>
                        </div>
                        <div class="col-2">
                          <div class="form-group">
                            <ValidationProvider
                              v-slot="{ errors, dirty }"
                              name="LocationState"
                              rules="required"
                            >
                              <CustomInput
                                id="txtLocationState"
                                label="Estado:"
                                placeholder="Puerto Rico"
                                disabled
                              />
                            </ValidationProvider>
                          </div>
                        </div>
                        <div class="col-2">
                          <div class="form-group">
                            <ValidationProvider
                              v-slot="{ errors, dirty }"
                              name="LocationCodPostal"
                              rules="required"
                            >
                              <CustomInput
                                id="txtLocationCodPostal"
                                label="Código Postal:"
                                placeholder="12345-0123"
                              />
                            </ValidationProvider>
                          </div>
                        </div>
                      </div>
                    </form>
                  </ValidationObserver>
                </div>
              </div>
              <div class="row">
                <div class="col-12 text-end pr-3">
                  <div class="dropdown-divider w-100" />
                  <ActionButton
                    i="fas fa-save"
                    variant="outline-danger m-2"
                    @click="showAddLocation = false"
                  >
                    Cancelar
                  </ActionButton>
                  <ActionButton i="fas fa-save" variant="success m-2">
                    Guardar
                  </ActionButton>
                </div>
              </div>
            </CustomCollapseItem>
          </CustomCollapse>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import TitleBreadcrumb from '@/components/common/page/TitleBreadcrumb';
import { SectionTitle } from '@/components/pei/shared';
import ActionButton from '@/components/common/ActionButton';
import CustomInput from '@/components/common/CustomInput';
import CustomDropDown from '@/components/common/CustomDropDown';
import CustomCollapse from '@/components/common/CustomCollapse';
import CustomCollapseItem from '@/components/common/CustomCollapseItem';
import DropDown from '@/components/common/menu/DropDown';

export default {
  name: 'SearchLocation',
  components: {
    ValidationObserver,
    ValidationProvider,
    TitleBreadcrumb,
    SectionTitle,
    ActionButton,
    CustomInput,
    CustomDropDown,
    CustomCollapse,
    CustomCollapseItem,
    DropDown,
  },
  data: () => ({
    page: {
      icon: 'fas fa-user-edit',
      title: 'Ubicación - Servicios',
      routes: [
        'Inicio',
        'PEI',
        'Ubicación Servicios',
        'Busqueda de ubicaciones',
      ],
    },
    customErrorMessages: {
      area: 'Favor de seleccionar un área',
      teacher: 'Favor de seleccionar el tipo de maestro',
      others: 'Favor de entrar la descripción del área Otros',
    },
    tableConfig: {
      totalRecords: 0,
      serverParams: {
        columnFilters: {},
        sort: {
          field: '',
          type: '',
        },
        page: 1,
        perPage: 10,
      },
      columns: [
        {
          label: 'Nombre',
          field: 'Nombre',
        },
        {
          label: 'Teléfono',
          field: 'Telefono',
        },
        {
          label: 'Ciudad',
          field: 'Ciudad',
        },
        {
          label: 'Código Postal',
          field: 'CodigoPostal',
        },
        {
          label: 'Acciones',
          field: 'Accion',
        },
      ],
      rows: [
        {
          Nombre: 'Adrián',
          Telefono: '+5491137550062',
          Ciudad: 'Buenos Aires',
          CodigoPostal: 1425,
          Accion: '',
        },
        {
          Nombre: 'Adrián',
          Telefono: '+5491137550062',
          Ciudad: 'Buenos Aires',
          CodigoPostal: 1425,
          Accion: '',
        },
      ],
    },
    showAddLocation: false,
  }),
};
</script>

<style scoped>
.text-end {
  text-align: end;
}

#searchLocationContainer >>> td,
#searchLocationContainer >>> tr,
#searchLocationContainer >>> th {
  text-align: center;
}

#searchLocationContainer >>> .vgt-searchLocation tbody {
  background: rgb(225, 228, 224);
  background: linear-gradient(
    180deg,
    rgba(225, 228, 224, 1) 0%,
    rgba(250, 251, 251, 1) 8%
  );
}

#searchLocationContainer >>> .vgt-searchLocation thead th {
  border-top: none;
  font-weight: bold;
}

#searchLocationContainer >>> .vgt-searchLocation td,
#searchLocationContainer >>> .vgt-searchLocation th {
  padding: 1em 10px;
  vertical-align: top;
  text-align: center;
  font: 1rem 'Lato';
  letter-spacing: 0;
  color: #11291b;
}

#searchLocationContainer >>> .vgt-searchLocation th {
  background-color: #3f5b60;
  color: white;
  font-weight: 400;
  border-bottom: 2px white solid;
}

#searchLocationContainer >>> .vgt-searchLocation th:first-child {
  border-radius: 10px 0 0 0;
}

#searchLocationContainer >>> .vgt-searchLocation th:last-child {
  border-radius: 0 10px 0 0;
}

#searchLocationContainer >>> .peiStatusCell {
  text-align: center;
  padding: 5px !important;
}

#searchLocationContainer >>> .peiActionCell {
  text-align: center;
  padding: 8px !important;
}

/*columna estatus*/
#searchLocationContainer >>> .vgt-searchLocation .tablebtn {
  padding: 0px 10px;
}
.min-width {
  width: 124px;
}
</style>
